import React from 'react';
import { loadReactComponent } from 'src/components/YandexMap/loaders/componentLoaders';
import { loadModulePromise } from 'src/components/YandexMap/mapLoader';
import type {
  Coordinates,
  ShortHotelInfo,
} from 'src/components/YandexMap/types';
import type { PopupState } from 'src/routes/SearchPage/store/map/types';
import Point from '../Point/Point';

const YMapFeatureDataSource = loadReactComponent(
  'YMapFeatureDataSource',
  loadModulePromise,
);
const YMapLayer = loadReactComponent('YMapLayer', loadModulePromise);

type ActiveHotelProps = {
  shortHotelInfo?: ShortHotelInfo;
  setPopupDataHandler: (popupData: PopupState) => void;
  moveToPoint: (
    coordinates: Coordinates,
    zoomDiff: number,
    offset: { x: number; y: number },
  ) => void;
  coordinates?: Coordinates;
  isMobile: boolean;
};

const ActiveHotelLayer = (props: ActiveHotelProps) => {
  const {
    shortHotelInfo,
    setPopupDataHandler,
    coordinates,
    moveToPoint,
    isMobile,
  } = props;

  const showActiveHotelPoint =
    shortHotelInfo && shortHotelInfo.price && coordinates;

  return (
    <>
      <YMapFeatureDataSource id="active-hotel" />
      <YMapLayer source="active-hotel" type="markers" zIndex={1500} />

      {showActiveHotelPoint ? (
        <Point
          isMobile={isMobile}
          active
          source="active-hotel"
          shortHotelInfo={shortHotelInfo}
          setPopupDataHandler={setPopupDataHandler}
          moveToPoint={moveToPoint}
          geometry={{
            type: 'Point',
            coordinates: coordinates as Coordinates,
          }}
        />
      ) : null}
    </>
  );
};

export default ActiveHotelLayer;
